
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.931 8.428a.99.99 0 00-1.25-.657l-7.758 2.37a.99.99 0 00-.66.657l-1.23 3.962H17.876c-.71 0-1.38.299-1.85.826a2.44 2.44 0 00-.6 1.932l4 31.62a2.475 2.475 0 002.449 2.15h14.418c1.24 0 2.29-.926 2.45-2.15l3.999-31.62a2.44 2.44 0 00-.6-1.932 2.469 2.469 0 00-1.85-.826h-4.17l.89-2.877 7.26-2.21a1 1 0 00.66-1.245zM17.517 16.91c.05-.06.17-.159.35-.159h15.537l-2.44 7.845c-5.299-.985-10.248-.1-12.567.468l-.98-7.795a.442.442 0 01.1-.358zm19.237 31.988a.472.472 0 01-.46.408H21.875c-.24 0-.44-.179-.46-.408l-2.76-21.843c2.42-.617 8.68-1.811 14.738.21 3.1 1.035 4.86 1.423 5.92 1.523l-2.56 20.11zm3.53-32.147c.18 0 .3.1.35.16.05.06.14.189.11.368l-1.21 9.547c-.66-.05-2.18-.328-5.53-1.443-.37-.12-.73-.23-1.1-.329l2.58-8.303h4.8z"}})])
          )
        }
      }
    